'use strict';

var _rollupPluginBabelHelpers = require('../../../../_rollupPluginBabelHelpers-D-dvSLAU.js');
var React = require('react');
var modules_auth_createLoggedInFetch_index = require('../../create-logged-in-fetch/index.js');

/** Decoded JWT token for the user. */

/**
 * Converts a raw encoded JWT token into its full JSON
 *   representation.
 *
 * @param token - Raw JWT token to decode.
 */
var decodeJwt = function decodeJwt(token) {
  if (token) {
    try {
      var payload = token.split('.')[1];
      var decoded = atob(payload);
      return JSON.parse(decoded);
    } catch (e) {
      console.error('Failed to parse JWT token', e);
    }
  }
  return undefined;
};
/**
 * Attempt to fetch a JWT token from the URL hash.
 *
 * If one is found, it will be removed from the hash so the user can't
 *   see it anymore, which helps prevent the token from being leaked
 *   accidentally by users sharing URLs/screenshots/etc.
 *
 * If one is not found in the hash, it'll fall back to the token
 *   stored in local storage (if present).
 */
var initializeJwt = function initializeJwt(hashParameterTokenKey, localStorageTokenKey) {
  if (window.location.hash.includes(hashParameterTokenKey)) {
    var match = window.location.hash.match(new RegExp("(&|#)".concat(hashParameterTokenKey, "=(.+?)(&|$)")));
    if (match) {
      var _match = _rollupPluginBabelHelpers._slicedToArray(match, 3),
        fullMatch = _match[0],
        replacement = _match[1],
        token = _match[2];
      // Remove the token from the hash params
      window.location.hash = window.location.hash.replace(fullMatch, replacement);
      // No need to include a separator at the end of the hash
      if (window.location.hash.endsWith(replacement)) {
        window.location.hash = window.location.hash.substring(0, window.location.hash.length - replacement.length);
      }
      localStorage.setItem(localStorageTokenKey, token);
      return token;
    }
  }
  return localStorage[localStorageTokenKey];
};

/**
 * A base class for Authorization Helpers that provides common functionality
 *   such as initializing the JWT token from local storage or the URL hash
 *   and parsing the token into a JSON object. The class can also be used to
 *   perform fetch requests with the JWT token attached to the request.
 *
 * This is an abstract class so anyone using it will have to bring their own
 *   implementations of login/logout functionality.
 */
var useBaseAuthHelper = function useBaseAuthHelper(_ref) {
  var hashParameterTokenKey = _ref.hashParameterTokenKey,
    localStorageTokenKey = _ref.localStorageTokenKey,
    fetchFunction = _ref.fetchFunction;
  var _useState = React.useState(initializeJwt(hashParameterTokenKey, localStorageTokenKey)),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    jwtToken = _useState2[0],
    setJwtToken = _useState2[1];
  var tokenInfo = React.useMemo(function () {
    return decodeJwt(jwtToken);
  }, [jwtToken]);
  var isLoggedIn = React.useMemo(function () {
    return !!jwtToken;
  }, [jwtToken]);

  /**
   * Update localStorage when the jwt token is changed.
   */
  React.useEffect(function () {
    if (jwtToken) {
      localStorage.setItem(localStorageTokenKey, jwtToken);
    } else {
      localStorage.removeItem(localStorageTokenKey);
    }
  }, [jwtToken, localStorageTokenKey]);

  /**
   * Curry the `createLoggedInFetch` function with this instance's
   *   `jwtToken` and `fetchFunction`. We use a `useMemo` instead
   *   of a `useCallback` here because we want the result of the
   *   curried function (the wrapped fetch function) to be memoized
   *   rather than the `createLoggedInFetch` function itself.
   */
  var loggedInFetch = React.useMemo(function () {
    return modules_auth_createLoggedInFetch_index.createLoggedInFetch({
      fetchFunction: fetchFunction,
      getJwtToken: function getJwtToken() {
        return jwtToken;
      }
    });
  }, [jwtToken, fetchFunction]);
  return {
    isLoggedIn: isLoggedIn,
    jwtToken: jwtToken,
    tokenInfo: tokenInfo,
    setJwtToken: setJwtToken,
    loggedInFetch: loggedInFetch
  };
};

exports.decodeJwt = decodeJwt;
exports.useBaseAuthHelper = useBaseAuthHelper;
//# sourceMappingURL=index.js.map
